export const CART_ADD_ITEMS                = '@@CART_ADD_ITEMS'
export const CART_CHANGE_ITEM_COUNT        = '@@CART_CHANGE_ITEM_COUNT'
export const CART_DELETE_ITEM              = '@@CART_DELETE_ITEM'
export const LOAD_CART_FROM_LOCALSTORAGE   = '@@LOAD_CART_FROM_LOCALSTORAGE'
export const CLEAR_CART                    = '@@CLEAR_CART'



// WEBPACK FOOTER //
// ./src/features/Cart/actionTypes.js